import Input from './Input';

const InputWithLabel = ({label, name, ...props}) => {
    return (
      <div>
        <label htmlFor={name} className="block text-sm font-medium leading-6 text-gray-900">
          {label}
        </label>
       <Input name={name} {...props}/>
      </div>
    )
  }

  export default InputWithLabel;
